export default {
  system: {
    user: 'Kullanıcı',
    level: 'Seviye',
    earnPerTap: 'Tıklama başına kazanç',
    coinsToLevelUp: 'Seviye atlamak için gereken para',
    profitPerHour: 'Saatlik kazanç',
    coming1: 'Yakında burada',
    coming2: 'ilginç bir şeyler olacak...',
    close: 'Kapat',
    friends: 'Arkadaşlar',
    continue: 'Devam et',
  },
  settings: {
    chooseNetwork: 'Ağ seç',
    chooseLanguage: 'Dil seç',
  },
  popup_CheckTask: {
    join: 'Katıl',
    check: 'Kontrol et',
    taskIsNotCompleted: 'Görev tamamlanmadı',
  },
  popup_levelUp: {
    levelUp: 'Seviye atladın!',
    multiTap: 'Çoklu tıklama',
    energyLimit: 'Enerji limiti',
  },
  popup_BalanceUp: {
    balanceUp: 'Bakiye güncellendi!',
    balanceDiffSinceLast: 'Ödülünüz',
  },
  popup_BalanceTip: {
    tip: 'Kazancınızı artırın',
    message: 'Ağınız için yükseltmeler almak için Maden menüsüne tıklayın',
    description: '3 saate kadar çevrimdışıyken bile kazanın',
  },
  popup_Bored: {
    header: 'Kurbağa sıkıldı!',
    message: 'Kurbağayla oynayın.',
    description: 'Kurbağayla 3 saat oynanmazsa, kazanç durur',
  },
  popup_Hungry: {
    header: 'Kurbağa acıktı!',
    message: 'Kurbağayı besleyin.',
    description: 'Ne kadar çok arkadaşınız varsa, her besleme o kadar çok para getirebilir',
  },
  menu: {
    network: 'Ağ',
    mine: 'Maden',
    earn: 'Kazan',
    food: 'Yemek',
  },
  tap: {
    bored: 'Sıkılmış',
    fun: 'Eğlenceli',
  },
  mineMenu: {
    activities: 'Etkinlikler',
    investments: 'Yatırımlar',
    web3: 'WEB3',
    achievements: 'Başarılar',
  },
  mine: {
    joinOurTG1: 'Telegram kanalımıza katılın,',
    joinOurTG2: 'açmak için!',
    unlock: 'Kilidi aç',
  },
  leaderboard: {
    from: 'den',
    beTheFirst: 'İlk olan siz olun!',
  },
  friends: {
    inviteFriends: 'Arkadaşlarını davet et!',
    receiveBonuses: 'Siz ve arkadaşınız bonus alacaksınız',
    inviteFriend: 'Arkadaş davet et',
    withTelegramPremium: 'Telegram Premium ile',
    forYouAndYourFriend: 'sizin ve arkadaşınız için',
    moreBonuses: 'Daha fazla bonus',
    listOfYourFriends: 'Arkadaş listeniz',
    linkCopied: 'Davet bağlantısı panoya kopyalandı!',
    playWithMe:
      'Bana katıl ve airdrop ile token kazanmak için oyna!\n' +
      '💰 Hediyeni kap! Yeni gelenler için +3000 para\n' +
      "🚀 Telegram Premium'un var mı? +5000 para kazan!\n",
  },
  earn: {
    moreCoins: 'Daha fazla para kazan!',
    dailyTasks: 'Günlük görevler',
    dailyReward: 'Günlük ödül',
    tasksList: 'Görev listesi',
    joinOurTG: 'Telegram kanalımıza katılın',
    followOurX: 'X hesabımızı takip edin',
    yourAd: 'Reklamınız burada olabilir',
    connect: 'Telegram kanalımızın yöneticisi ile iletişime geçin',
  },
  food: {
    hungry: 'Aç',
    full: 'Tok',
    frogIsFull: 'Kurbağa tok',
    feed: 'Besle',
    bonus: 'Bonus',
    satiety: 'Tokluk',
    hours: 'saat',
  },
  toast: {
    buyCard: {
      title: 'Başarım Açıldı!',
      subtitle: 'Kurbağa imparatorluğunuzu büyüklüğe taşıma zamanı 👑',
    },
    feedFrog: {
      title: 'Kurbağa Mutlu!',
      subtitle: 'Harika iş! Gülümsemelerin devam etmesi için evcil hayvanınızı besleyin 🍽️',
    },
  },
};
